import { useCallback, useMemo } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { ResourceStatusEnum } from '@/types/schema';

import { getMenuItems, LABEL_CONFIG } from './config';
import { PreviewMenuProps } from './types';

export const usePreviewLabelPopover = ({
  previewId,
  setPreviewId,
  versionConfigs,
}: PreviewMenuProps) => {
  const [showPopover, { toggle: togglePopover }] = useToggle(false);
  const menuItems = useMemo(() => getMenuItems(versionConfigs), [versionConfigs]);
  const selectedStatus = useMemo(
    () => versionConfigs.find((item) => item.rootBlockId === previewId)?.status,
    [previewId, versionConfigs],
  );
  const selectedLabel = useMemo(
    () => LABEL_CONFIG[selectedStatus! as ResourceStatusEnum.Draft | ResourceStatusEnum.Published],
    [selectedStatus],
  );

  const menuItemClick = useCallback(
    (id: string) => {
      setPreviewId(id);
      togglePopover();
    },
    [setPreviewId, togglePopover],
  );

  return { menuItems, menuItemClick, selectedLabel, togglePopover, showPopover };
};

export default usePreviewLabelPopover;
